import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import Divider from "components/ui/Divider";
import BookReviews from "components/BookReview/BookReviews";
import { PageSerializersBooksShow, UserBookSerializersUserBookReview } from "types/serializers";

export default function FollowingReviews({
  exclude = [],
  reviews,
  book,
  limit = 3,
}: {
  exclude?: UserBookSerializersUserBookReview[];
  book: PageSerializersBooksShow;
  reviews: UserBookSerializersUserBookReview[];
  limit?: number;
}) {
  const ids = exclude.map((r) => r.id);
  const filteredReviews = reviews.filter((review) => ids.indexOf(review.id) === -1).slice(0, limit);
  if (filteredReviews.length === 0) {
    return false;
  }

  return (
    <div>
      <div className="mb-4">
        <Heading level={3} size="md">
          Friend Reviews
        </Heading>
        <Text as="p" variant="secondary">
          Reviews by readers you follow.
        </Text>
      </div>

      <BookReviews reviews={filteredReviews} book={book} expandClass="max-h-64" />
      <Divider />
    </div>
  );
}
